<template>
  <div class="user">
    <transition name="slide-fade">
      <div class="edit-page" v-show="pwdPass === false">
        <div class="title">案件填写</div>
        <div class="password el-form" label-position="top">
          <el-form :inline="true" label-width="100px">
            <el-form-item label="密码">
              <el-input size="small" v-model="pwd" placeholder="请输入密码" clearable></el-input>
            </el-form-item>
            <p class="text-danger">{{ errmsg }}</p>
            <el-form-item class="btn">
              <el-button type="primary" size="small" class="save" v-show="!addForm.id" @click="queryShareCase()">
                验证
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </transition>
    <transition name="slide-fade">
      <div class="edit-page" v-show="pwdPass === true">
        <div class="title">案件填写</div>
        <div class="el-form" label-position="top">
          <el-form ref="addForm" :model="addForm" label-width="100px" :rules="rules">
            <el-row>
              <el-col :xs="24" :sm="24">
                <el-form-item label="业务类型" prop="businessType">
                  <el-select
                    size="small"
                    v-model="addForm.businessType"
                    placeholder="请选择"
                    @change="businessTypeChange"
                  >
                    <el-option
                      :label="item.name"
                      :value="item.name"
                      v-for="item in businessTypes"
                      :key="item.name"
                      :disabled="true"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8">
                <el-form-item label="公司名称" prop="companyName">
                  <el-select
                    class="width-100"
                    size="small"
                    v-if="addForm.businessTypeCode !== '1'"
                    v-model="addForm.companyName"
                    placeholder="请选择"
                    filterable
                  >
                    <el-option
                      :label="item.name"
                      :value="item.name"
                      v-for="(item, index) in customers"
                      :key="'2-' + index"
                    >
                    </el-option>
                  </el-select>
                  <el-input
                    type="text"
                    size="small"
                    v-model="addForm.companyName"
                    placeholder="不在选择项的，请输入"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="公司备用名称" prop="progress">
                  <el-input size="small" type="textarea" v-model="addForm.companyName1" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="" label-width="20px">
                  <div class="text-warning">*请填写3~5个，2字名称近似度高</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="24" :sm="24" v-if="addForm.businessTypeCode === '4'">
                <el-form-item label="项目名称" prop="projectName">
                  <el-input type="text" size="small" v-model="addForm.projectName" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="8" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="纳税性质" prop="taxNature">
                  <el-select size="small" v-model="addForm.taxNature" placeholder="请选择">
                    <el-option :label="item.name" :value="item.name" v-for="item in taxs" :key="item.name"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :xs="24" :sm="8" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="是否代账" prop="isBookkeeping">
                  <el-radio-group v-model="addForm.isBookkeeping">
                    <el-radio label="1">是</el-radio>
                    <el-radio label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col> -->
              <el-col :xs="24" :sm="8" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="注册资金" prop="registeredCapital">
                  <el-input size="small" v-model="addForm.registeredCapital" placeholder="请输入">
                    <template slot="append">万元</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="24" :sm="8" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="法人" prop="legalPerson">
                  <el-input type="text" size="small" v-model="addForm.legalPerson" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="8" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="法人身份证头像面" prop="legalPersonIdcardHead" label-width="180px">
                  <el-image
                    v-show="addForm.legalPersonIdcardHead"
                    style="width: 100px;vertical-align: middle; height: auto"
                    :src="addForm.legalPersonIdcardHead"
                    :preview-src-list="[addForm.legalPersonIdcardHead]"
                  >
                  </el-image>
                  <span class="img-box">
                    <div :class="{ upload: !addForm.legalPersonIdcardHead, mask: addForm.legalPersonIdcardHead }">
                      <div v-show="!addForm.legalPersonIdcardHead"></div>
                      <div class="text" v-show="addForm.legalPersonIdcardHead">重新上传</div>
                      <input
                        type="file"
                        name="legalPersonIdcardHead"
                        accept="image/*"
                        :class="{
                          'upload-file': !addForm.legalPersonIdcardHead,
                          'mask-file': addForm.legalPersonIdcardHead
                        }"
                        ref="legalPersonIdcardHead"
                        @change="picReadUpload($event, 'addForm')"
                      />
                    </div>
                  </span>
                  <div
                    v-show="addForm.legalPersonIdcardHead"
                    class="text-primary"
                    @click="downloadIamge(addForm.legalPersonIdcardHead, '法人身份证头像面')"
                  >
                    图片下载
                  </div>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="8" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="法人身份证国徽面" prop="legalPersonIdcardEmblem" label-width="180px">
                  <el-image
                    v-show="addForm.legalPersonIdcardEmblem"
                    style="width: 100px;vertical-align: middle; height: auto"
                    :src="addForm.legalPersonIdcardEmblem"
                    :preview-src-list="[addForm.legalPersonIdcardEmblem]"
                  >
                  </el-image>
                  <span class="img-box">
                    <div :class="{ upload: !addForm.legalPersonIdcardEmblem, mask: addForm.legalPersonIdcardEmblem }">
                      <div v-show="!addForm.legalPersonIdcardEmblem"></div>
                      <div class="text" v-show="addForm.legalPersonIdcardEmblem">重新上传</div>
                      <input
                        type="file"
                        name="legalPersonIdcardEmblem"
                        accept="image/*"
                        :class="{
                          'upload-file': !addForm.legalPersonIdcardEmblem,
                          'mask-file': addForm.legalPersonIdcardEmblem
                        }"
                        ref="legalPersonIdcardEmblem"
                        @change="picReadUpload($event, 'addForm')"
                      />
                    </div>
                  </span>
                  <div
                    v-show="addForm.legalPersonIdcardEmblem"
                    class="text-primary"
                    @click="downloadIamge(addForm.legalPersonIdcardEmblem, '法人身份证国徽面')"
                  >
                    图片下载
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="24" :sm="8" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="监事" prop="supervisor">
                  <el-input type="text" size="small" v-model="addForm.supervisor" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="8" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="监事身份证头像面" prop="supervisorIdcardHead" label-width="180px">
                  <el-image
                    v-show="addForm.supervisorIdcardHead"
                    style="width: 100px;vertical-align: middle; height: auto"
                    :src="addForm.supervisorIdcardHead"
                    :preview-src-list="[addForm.supervisorIdcardHead]"
                  >
                  </el-image>
                  <span class="img-box">
                    <div :class="{ upload: !addForm.supervisorIdcardHead, mask: addForm.supervisorIdcardHead }">
                      <div v-show="!addForm.supervisorIdcardHead"></div>
                      <div class="text" v-show="addForm.supervisorIdcardHead">重新上传</div>
                      <input
                        type="file"
                        name="supervisorIdcardHead"
                        accept="image/*"
                        :class="{
                          'upload-file': !addForm.supervisorIdcardHead,
                          'mask-file': addForm.supervisorIdcardHead
                        }"
                        ref="supervisorIdcardHead"
                        @change="picReadUpload($event, 'addForm')"
                      />
                    </div>
                  </span>
                  <div
                    v-show="addForm.supervisorIdcardHead"
                    class="text-primary"
                    @click="downloadIamge(addForm.supervisorIdcardHead, '监事身份证头像面')"
                  >
                    图片下载
                  </div>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="8" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="监事身份证国徽面" prop="supervisorIdcardEmblem" label-width="180px">
                  <el-image
                    v-show="addForm.supervisorIdcardEmblem"
                    style="width: 100px;vertical-align: middle; height: auto"
                    :src="addForm.supervisorIdcardEmblem"
                    :preview-src-list="[addForm.supervisorIdcardEmblem]"
                  >
                  </el-image>
                  <span class="img-box">
                    <div :class="{ upload: !addForm.supervisorIdcardEmblem, mask: addForm.supervisorIdcardEmblem }">
                      <div v-show="!addForm.supervisorIdcardEmblem"></div>
                      <div class="text" v-show="addForm.supervisorIdcardEmblem">重新上传</div>
                      <input
                        type="file"
                        name="supervisorIdcardEmblem"
                        accept="image/*"
                        :class="{
                          'upload-file': !addForm.supervisorIdcardEmblem,
                          'mask-file': addForm.supervisorIdcardEmblem
                        }"
                        ref="supervisorIdcardEmblem"
                        @change="picReadUpload($event, 'addForm')"
                      />
                    </div>
                  </span>
                  <div
                    v-show="addForm.supervisorIdcardEmblem"
                    class="text-primary"
                    @click="downloadIamge(addForm.supervisorIdcardEmblem, '监事身份证国徽面')"
                  >
                    图片下载
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="24" :sm="8" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="财务负责人" prop="treasurer">
                  <el-input type="text" size="small" v-model="addForm.treasurer" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="8" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="财务负责人身份证头像面" prop="treasurerIdcardHead" label-width="180px">
                  <el-image
                    v-show="addForm.treasurerIdcardHead"
                    style="width: 100px;vertical-align: middle; height: auto"
                    :src="addForm.treasurerIdcardHead"
                    :preview-src-list="[addForm.treasurerIdcardHead]"
                  >
                  </el-image>
                  <span class="img-box">
                    <div :class="{ upload: !addForm.treasurerIdcardHead, mask: addForm.treasurerIdcardHead }">
                      <div v-show="!addForm.treasurerIdcardHead"></div>
                      <div class="text" v-show="addForm.treasurerIdcardHead">重新上传</div>
                      <input
                        type="file"
                        name="treasurerIdcardHead"
                        accept="image/*"
                        :class="{
                          'upload-file': !addForm.treasurerIdcardHead,
                          'mask-file': addForm.treasurerIdcardHead
                        }"
                        ref="treasurerIdcardHead"
                        @change="picReadUpload($event, 'addForm')"
                      />
                    </div>
                  </span>
                  <div
                    v-show="addForm.treasurerIdcardHead"
                    class="text-primary"
                    @click="downloadIamge(addForm.treasurerIdcardHead, '财务负责人身份证头像面')"
                  >
                    图片下载
                  </div>
                </el-form-item>
              </el-col>
              <el-col :xs="12" :sm="8" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="财务负责人身份证国徽面" prop="treasurerIdcardEmblem" label-width="180px">
                  <el-image
                    v-show="addForm.treasurerIdcardEmblem"
                    style="width: 100px;vertical-align: middle; height: auto"
                    :src="addForm.treasurerIdcardEmblem"
                    :preview-src-list="[addForm.treasurerIdcardEmblem]"
                  >
                  </el-image>
                  <span class="img-box">
                    <div :class="{ upload: !addForm.treasurerIdcardEmblem, mask: addForm.treasurerIdcardEmblem }">
                      <div v-show="!addForm.treasurerIdcardEmblem"></div>
                      <div class="text" v-show="addForm.treasurerIdcardEmblem">重新上传</div>
                      <input
                        type="file"
                        name="treasurerIdcardEmblem"
                        accept="image/*"
                        :class="{
                          'upload-file': !addForm.treasurerIdcardEmblem,
                          'mask-file': addForm.treasurerIdcardEmblem
                        }"
                        ref="treasurerIdcardEmblem"
                        @change="picReadUpload($event, 'addForm')"
                      />
                    </div>
                  </span>
                  <div
                    v-show="addForm.treasurerIdcardEmblem"
                    class="text-primary"
                    @click="downloadIamge(addForm.treasurerIdcardEmblem, '财务负责人身份证国徽面')"
                  >
                    图片下载
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="24" :sm="24" v-if="addForm.businessTypeCode === '1'">
                <el-table v-if="showState === 'pc'" class="show-pc" :data="caseShareholders" style="width: 100%">
                  <el-table-column label="股东">
                    <template slot-scope="scope">
                      <el-input
                        type="text"
                        size="small"
                        v-show="scope.row.state === 'add'"
                        v-model="caseShareholderForm.name"
                        placeholder="请输入股东"
                      ></el-input>
                      <span v-show="scope.row.state !== 'add'">{{ scope.row.name }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column class="show-pc" label="占股比例">
                    <template slot-scope="scope">
                      <el-input
                        size="small"
                        type="number"
                        max="100"
                        min="0"
                        v-show="scope.row.state === 'add'"
                        v-model="caseShareholderForm.shareProportion"
                        placeholder="请输入占股比例"
                      >
                        <template slot="append">%</template>
                      </el-input>
                      <span v-show="scope.row.state !== 'add'">{{ scope.row.shareProportion }} %</span>
                    </template>
                  </el-table-column>
                  <el-table-column width="120px" label="国徽面">
                    <template slot-scope="scope">
                      <span v-show="scope.row.state !== 'add'">
                        <el-image
                          style="width: 100px;vertical-align: middle; height: auto"
                          :src="scope.row.idcardEmblem"
                          :preview-src-list="[scope.row.idcardEmblem]"
                        >
                        </el-image>
                      </span>
                      <!-- 选择图片预览 -->
                      <span v-show="scope.row.state === 'add'">
                        <el-image
                          style="width: 100px;vertical-align: middle; height: auto"
                          :src="caseShareholderForm.idcardEmblem"
                          :preview-src-list="[caseShareholderForm.idcardEmblem]"
                        >
                        </el-image>
                      </span>
                      <span v-show="scope.row.state === 'add'" class="img-box">
                        <!-- 选择按钮 -->
                        <div
                          :class="{ upload: !caseShareholderForm.idcardEmblem, mask: caseShareholderForm.idcardEmblem }"
                        >
                          <div class="text" v-show="caseShareholderForm.idcardEmblem">重新上传</div>
                          <input
                            type="file"
                            name="idcardEmblem"
                            accept="image/*"
                            :class="{
                              'upload-file': !caseShareholderForm.idcardEmblem,
                              'mask-file': caseShareholderForm.idcardEmblem
                            }"
                            ref="idcardEmblem"
                            @change="picReadUpload($event, 'caseShareholderForm')"
                          />
                        </div>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column width="120px" label="头像面">
                    <template slot-scope="scope">
                      <span v-show="scope.row.state !== 'add'">
                        <el-image
                          style="width: 100px;vertical-align: middle; height: auto"
                          :src="scope.row.idcardHead"
                          :preview-src-list="[scope.row.idcardHead]"
                        >
                        </el-image>
                      </span>
                      <!-- 选择图片预览 -->
                      <span v-show="scope.row.state === 'add'">
                        <el-image
                          style="width: 100px;vertical-align: middle; height: auto"
                          :src="caseShareholderForm.idcardHead"
                          :preview-src-list="[caseShareholderForm.idcardHead]"
                        >
                        </el-image>
                      </span>
                      <span v-show="scope.row.state === 'add'" class="img-box">
                        <!-- 选择按钮 -->
                        <div :class="{ upload: !caseShareholderForm.idcardHead, mask: caseShareholderForm.idcardHead }">
                          <div class="text" v-show="caseShareholderForm.idcardHead">重新上传</div>
                          <input
                            type="file"
                            name="idcardHead"
                            accept="image/*"
                            :class="{
                              'upload-file': !caseShareholderForm.idcardHead,
                              'mask-file': caseShareholderForm.idcardHead
                            }"
                            ref="idcardHead"
                            @change="picReadUpload($event, 'caseShareholderForm')"
                          />
                        </div>
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column width="180px">
                    <template slot="header">
                      操作 <el-button type="success" size="small" @click="addCaseShareholder">新增股东</el-button>
                    </template>
                    <template slot-scope="scope">
                      <el-button
                        v-show="scope.row.state === 'add'"
                        type="primary"
                        size="small"
                        class="save"
                        @click="caseShareholderFormSave(scope.$index, 'caseShareholderForm')"
                        >保存</el-button
                      >
                      <el-button size="mini" plain type="danger" @click="delCaseShareholder(scope.$index, scope.row)">
                        删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-table
                  v-if="showState === 'phone'"
                  class="show-phone"
                  :data="caseShareholders"
                  style="width: 100%"
                  :span-method="spanMethod4"
                >
                  <el-table-column label="股东信息">
                    <template slot-scope="scope">
                      <div v-show="scope.row.state === 'add'">
                        <el-input
                          type="text"
                          size="small"
                          v-model="caseShareholderForm.name"
                          placeholder="请输入股东"
                        ></el-input>
                        <br />
                        <el-input
                          size="small"
                          type="number"
                          max="100"
                          min="0"
                          v-model="caseShareholderForm.shareProportion"
                          placeholder="请输入占股比例"
                        >
                          <template slot="append">%</template>
                        </el-input>
                        <br />
                        <span>国徽面</span>
                        <!-- 选择图片预览 -->
                        <span v-show="scope.row.state === 'add'">
                          <el-image
                            v-show="caseShareholderForm.idcardEmblem"
                            style="width: 100px;vertical-align: middle; height: auto;margin-left:10px"
                            :src="caseShareholderForm.idcardEmblem"
                            :preview-src-list="[caseShareholderForm.idcardEmblem]"
                          >
                          </el-image>
                        </span>
                        <span class="img-box">
                          <!-- 选择按钮 -->
                          <div
                            :class="{
                              upload: !caseShareholderForm.idcardEmblem,
                              mask: caseShareholderForm.idcardEmblem
                            }"
                          >
                            <div class="text" v-show="caseShareholderForm.idcardEmblem">重新上传</div>
                            <input
                              type="file"
                              name="idcardEmblem"
                              accept="image/*"
                              :class="{
                                'upload-file': !caseShareholderForm.idcardEmblem,
                                'mask-file': caseShareholderForm.idcardEmblem
                              }"
                              ref="idcardEmblem"
                              @change="picReadUpload($event, 'caseShareholderForm')"
                            />
                          </div>
                        </span>
                        <br />
                        <span>头像面</span>
                        <span v-show="scope.row.state === 'add'">
                          <el-image
                            v-show="caseShareholderForm.idcardHead"
                            style="width: 100px;vertical-align: middle; height: auto;margin-left:10px"
                            :src="caseShareholderForm.idcardHead"
                            :preview-src-list="[caseShareholderForm.idcardHead]"
                          >
                          </el-image>
                        </span>
                        <span class="img-box">
                          <!-- 选择按钮 -->
                          <div
                            :class="{ upload: !caseShareholderForm.idcardHead, mask: caseShareholderForm.idcardHead }"
                          >
                            <div class="text" v-show="caseShareholderForm.idcardHead">重新上传</div>
                            <input
                              type="file"
                              name="idcardHead"
                              accept="image/*"
                              :class="{
                                'upload-file': !caseShareholderForm.idcardHead,
                                'mask-file': caseShareholderForm.idcardHead
                              }"
                              ref="idcardHead"
                              @change="picReadUpload($event, 'caseShareholderForm')"
                            />
                          </div>
                        </span>
                      </div>
                      <div v-show="scope.row.state !== 'add'">
                        <table style="border:0;width:100%">
                          <tr>
                            <td style="width:50%;border:0">股东：{{ scope.row.name }}</td>
                            <td style="width:50%;border:0">占股比例：{{ scope.row.shareProportion }} %</td>
                          </tr>
                          <tr>
                            <td style="width:50%;border:0">
                              <div>国徽面</div>
                              <el-image
                                style="width: 100px;vertical-align: middle; height: auto"
                                :src="scope.row.idcardEmblem"
                                :preview-src-list="[scope.row.idcardEmblem]"
                              >
                              </el-image>
                            </td>
                            <td style="width:50%;border:0">
                              <div>头像面</div>
                              <el-image
                                style="width: 100px;vertical-align: middle; height: auto"
                                :src="scope.row.idcardHead"
                                :preview-src-list="[scope.row.idcardHead]"
                              >
                              </el-image>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column width="50px" label=" "> </el-table-column>
                  <el-table-column width="50px" label=" "></el-table-column>
                  <el-table-column width="50px" label=" "></el-table-column>
                  <el-table-column width="100px">
                    <template slot="header">
                      操作 <el-button type="success" size="small" @click="addCaseShareholder">新增股东</el-button>
                    </template>
                    <template slot-scope="scope">
                      <div class="show-pc">
                        <el-button
                          v-show="scope.row.state === 'add'"
                          type="primary"
                          size="small"
                          class="save"
                          @click="caseShareholderFormSave(scope.$index, 'caseShareholderForm')"
                          >保存</el-button
                        >
                        <el-button size="mini" plain type="danger" @click="delCaseShareholder(scope.$index, scope.row)">
                          删除
                        </el-button>
                      </div>
                      <div class="show-phone">
                        <el-button
                          v-show="scope.row.state === 'add'"
                          type="primary"
                          size="small"
                          class="save"
                          @click="caseShareholderFormSave(scope.$index, 'caseShareholderForm')"
                          >保存</el-button
                        >
                        <br />
                        <br />
                        <el-button size="mini" plain type="danger" @click="delCaseShareholder(scope.$index, scope.row)">
                          删除
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-form-item class="show-pc" label="区域" prop="qy">
                  <el-cascader
                    class="width-100"
                    v-model="addForm.qy"
                    placeholder="请选择区域"
                    :options="options"
                    filterable
                    @change="qyChange"
                  >
                  </el-cascader>
                </el-form-item>
                <el-form-item class="show-phone" label="区域">
                  <div @click="popupShow">
                    <el-input size="small" v-model="addForm.qy2" :disabled="true"></el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="注册地址" prop="address">
                  <el-input type="text" size="small" v-model="addForm.address" placeholder="注册地址"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" v-if="addForm.businessTypeCode === '1'">
                <el-form-item label="经营范围" prop="natureOfBusiness">
                  <el-input size="small" type="textarea" v-model="addForm.natureOfBusiness"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <el-form-item label="备注" prop="remark">
                  <el-input size="small" type="textarea" v-model="addForm.remark"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item class="btn">
              <el-button type="primary" size="small" class="save" @click="addSave('addForm')">保存 </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </transition>
    <van-popup v-model="popupShowState" position="bottom" :style="{ height: '' }" :lazy-render="false">
      <van-picker
        ref="picker2"
        show-toolbar
        title="区域"
        :columns="options"
        cancel-button-text="清空"
        @confirm="pickerConfirm"
        @cancel="pickerCancel"
      />
    </van-popup>
  </div>
</template>

<script>
import cityData from '../../utils/Data'
export default {
  name: 'Detail',
  props: {
    detailData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    detailPersons: {
      type: Array,
      default: () => {
        return []
      }
    },
    webState: {
      type: String,
      default: 'add'
    },
    caseId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      userInfo: {},
      titles: ['案件填写'],
      web: 'main',
      showState: '',
      pwdPass: false, // 密码验证通过
      pwd: '',
      errmsg: '', // 错误信息
      addForm: {
        companyName: '', // 公司名称
        companyName1: '', // 公司名称
        projectName: '', // 项目名称
        businessType: '', // 业务类型
        taxNature: '', // 纳税性质
        registeredCapital: '', // 注册资金
        legalPerson: '', // 法人
        legalPersonIdcardEmblem: '', // 法人身份证国徽面
        legalPersonIdcardHead: '', // 法人身份证头像面
        supervisor: '', // 监事
        supervisorIdcardEmblem: '', // 监事身份证国徽面
        supervisorIdcardHead: '', // 监事身份证头像面
        treasurer: '', // 财务负责人
        treasurerIdcardEmblem: '', // 财务负责人身份证国徽面
        treasurerIdcardHead: '', // 财务负责人身份证头像面
        natureOfBusiness: '', // 经营范围
        isBookkeeping: '', // 是否代账
        customerManagerId: '', // 客户经理
        customerManagerName: '', // 客户经理
        caseAccountant: [], // 负责人
        advancePayment: '', // 预付款
        caseType: '', // 案件类型
        state: '', // 状态
        finalPayment: '', // 尾款
        remark: '', // 备注
        picJdcmp: '',
        picJdcmp2: '',
        caseChange: [],
        qy: '', // 区域
        qy2: '' // 区域
      },
      businessTypes: [],
      taxs: [],
      states: [],
      customers: [], // 公司客户数组
      caseTypes: [],
      picJdcmp: { src: '', file: '', name: '图片' },
      picJdcmp2: { src: '', file: '', name: '文件' },
      pics: [],
      files: [],
      persons: [], // 公司所有用户
      caseAccountants: [], // 负责人
      caseContacts: [], // 案件联系人
      caseContactForm: {
        name: '',
        phone: ''
      }, // 案件联系人表单
      caseShareholders: [], // 股东数组
      caseShareholderForm: {
        name: '',
        shareProportion: '',
        idcardEmblem: '', // 股东身份证国徽面
        idcardHead: ''
      }, // 股东表单
      caseChanges: [], // 变更项数组
      caseChangeForm: {
        name: ''
      }, // 变更项表单
      changes: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      supervisorForm: {
        supervisor: '', // 监事
        supervisorIdcardEmblem: '', // 监事身份证国徽面
        supervisorIdcardHead: '' // 监事身份证头像面
      },
      treasurerForm: {
        treasurer: '', // 财务负责人
        treasurerIdcardEmblem: '', // 财务负责人身份证国徽面
        treasurerIdcardHead: '' // 财务负责人身份证头像面
      },
      legalPersonForm: {
        legalPerson: '', // 法人
        legalPersonIdcardEmblem: '', // 法人身份证国徽面
        legalPersonIdcardHead: '' // 法人身份证头像面
      },
      options: cityData,
      popupShowState: false,
      rules: {
        businessType: [{ type: 'string', required: true, message: '请输入业务类型', trigger: 'blur' }]
        // companyName: [{ type: 'any', message: '请输入公司名称', trigger: 'blur' }],
        // taxNature: [{ type: 'any', message: '请选择纳税性质', trigger: 'change' }],
        // registeredCapital: [{ type: 'any', message: '请输入注册资金', trigger: 'blur' }],
        // legalPerson: [{ type: 'any', message: '请输入法人', trigger: 'blur' }],
        // supervisor: [{ type: 'any', message: '请输入监事', trigger: 'blur' }],
        // treasurer: [{ type: 'any', message: '请输入财务负责人', trigger: 'blur' }],
        // natureOfBusiness: [{ message: '请输入经营范围', trigger: 'blur' }],
        // qy: [{ type: 'any', message: '请选择区域', trigger: 'blur' }],
        // address: [{ type: 'any', message: '请输入注册地址 ', trigger: 'blur' }],
        // isBookkeeping: [{ type: 'any', message: '请选择是否代账', trigger: 'change' }],
        // customerManagerId: [{ type: 'any', message: '请选择客户经理', trigger: 'change' }],
        // caseAccountant: [{ type: 'any', message: '请选择负责人', trigger: 'change' }],
        // advancePayment: [{ type: 'any', message: '请输入预付款', trigger: 'blur' }],
        // caseType: [{ type: 'any', message: '请选择案件类型', trigger: 'change' }],
        // state: [{ type: 'any', message: '请选择状态', trigger: 'change' }],
        // finalPayment: [{ type: 'any', message: '请输入尾款', trigger: 'blur' }],
        // caseChange: [{ type: 'any', message: '请选择变更项', trigger: 'change' }],
        // remark: [{ type: 'any', message: '请输入备注', trigger: 'blur' }]
      }
    }
  },
  methods: {
    spanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return [1, 2]
      } else if (columnIndex === 1) {
        return [0, 0]
      }
    },
    spanMethod4({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return [1, 4]
      } else if (columnIndex === 1) {
        return [0, 0]
      } else if (columnIndex === 2) {
        return [0, 0]
      } else if (columnIndex === 3) {
        return [0, 0]
      }
    },
    init() {
      this.queryCode(0)
      this.queryCode(1)
      this.queryCode(3)
      this.queryCode(4)
      this.queryCode(5)
      if (this.addForm.id) {
        // this.queryUserIdName() // 查询公司下员工
        this.queryShareholder() // 查询股东
      }
      console.log(this.$refs.picker2)
      // this.$refs.picker2.setValues(this.addForm.qy)
    },
    titleClick(item, index) {
      console.log(item, index)
      if (item === '案件中心') {
        this.web = 'main'
        this.titles = ['案件中心'] // 导航菜单
      }
    },
    popupShow() {
      this.popupShowState = true
    },
    // 区域更改
    qyChange(val) {
      if (val) {
        this.addForm.area1 = val[0]
        this.addForm.area2 = val[1]
        this.addForm.area3 = val[2]
        this.addForm.qy2 = val.join('/')
        this.$refs.picker2.setValues(this.addForm.qy)
      }
    },
    // 区域选择
    pickerConfirm(val, indexs) {
      this.addForm.qy = val
      this.addForm.qy2 = val.join('/')
      this.addForm.area1 = val[0]
      this.addForm.area2 = val[1]
      this.addForm.area3 = val[2]
      this.popupShowState = false
    },
    pickerCancel() {
      this.addForm.qy = []
      this.addForm.qy2 = ''
      this.addForm.area1 = ''
      this.addForm.area2 = ''
      this.addForm.area3 = ''
      this.popupShowState = false
    },
    // 业务类型修改
    businessTypeChange(val) {
      for (let i = 0; i < this.businessTypes.length; i++) {
        if (this.businessTypes[i].name === val) {
          this.addForm.businessTypeCode = this.businessTypes[i].code
          console.log('businessTypeCode:' + this.addForm.businessTypeCode)
        }
      }
    },
    // 客户经理选择变化
    customerManagerChange(val) {
      for (let i = 0; i < this.persons.length; i++) {
        if (this.persons[i].id === val) {
          this.addForm.customerManagerName = this.persons[i].name
        }
      }
      console.log(this.addForm)
    },
    // 负责人选择变化
    caseAccountantChange(val) {
      if (this.addForm.id) {
        console.log(val)
        console.log(this.caseAccountants)
        if (val.length < this.caseAccountants.length) {
          const ids = []
          for (let i = 0; i < this.caseAccountants.length; i++) {
            ids.push(this.caseAccountants[i].uid)
          }
          const arr = ids.filter(item => {
            return val.indexOf(item) < 0
          })
          this.delAccountant(arr[0])
          console.log(arr)
          return false // 删除操作
        } else {
          const ids = []
          for (let i = 0; i < this.caseAccountants.length; i++) {
            ids.push(this.caseAccountants[i].uid)
          }
          const arr = val.filter(item => {
            return ids.indexOf(item) < 0
          })
          let name = ''
          for (let i = 0; i < this.persons.length; i++) {
            if (this.persons[i].id === arr[0]) {
              name = this.persons[i].name
            }
          }
          console.log(name)
          const param = {
            caseId: this.addForm.id,
            name: name,
            uid: arr[0]
          }
          this.$post('/case/addAccountant', param).then(
            result => {
              if (result.status === 200) {
                this.queryAccountant()
                this.$refs.caseAccountant.blur()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
          console.log(arr)
        }
      } else {
        const caseAccountants = []
        for (let i = 0; i < this.persons.length; i++) {
          for (let j = 0; j < val.length; j++) {
            if (this.persons[i].id === val[j]) {
              caseAccountants.push({
                uid: this.persons[i].id,
                name: this.persons[i].name
              })
            }
          }
        }
        this.caseAccountants = caseAccountants
      }
    },
    // 删除负责人
    delAccountant(val) {
      let id = ''
      for (let i = 0; i < this.caseAccountants.length; i++) {
        if (val === this.caseAccountants[i].uid) {
          id = this.caseAccountants[i].id
        }
      }
      const param = {
        id: id
      }
      this.$get('/case/deleteAccountant', param).then(
        result => {
          if (result.status === 200) {
            this.queryAccountant()
            this.$refs.caseAccountant.blur()
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    /**
     * 查询变更项
      system/code/query?systemId=0&businessId=0
      纳税性质
      system/code/query?systemId=0&businessId=1
      计费周期
      system/code/query?systemId=0&businessId=2
      案件状态
      system/code/query?systemId=0&businessId=3
      案件类型
      system/code/query?systemId=0&businessId=4
      案件业务类型
      system/code/query?systemId=0&businessId=5
    */
    queryCode(businessId) {
      const param = {
        systemId: 0,
        businessId: businessId
      }
      this.$get('/system/code/query', param).then(
        result => {
          if (result.status === 200) {
            if (businessId === 0) {
              this.changes = result.data
            } else if (businessId === 1) {
              this.taxs = result.data
            } else if (businessId === 2) {
              this.circles = result.data
            } else if (businessId === 3) {
              this.states = result.data
            } else if (businessId === 4) {
              this.caseTypes = result.data
            } else if (businessId === 5) {
              this.businessTypes = result.data
              this.businessTypeChange(this.addForm.businessType)
            }
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 密码验证 查询案件信息
    queryShareCase() {
      if (!this.pwd) {
        this.errmsg = '请填写密码！'
        return
      }
      const param = {
        id: this.$route.params.id,
        pwd: this.pwd
      }
      this.$get('/case/queryShareCase', param).then(
        result => {
          if (result.status === 200) {
            if (result.msg === '密码错误') {
              this.$common.session.rempve('pwd') // 保存密码
              this.errmsg = '密码错误'
              return
            }
            this.$common.session.set('pwd', this.pwd) // 保存密码
            this.pwdPass = true // 密码验证通过
            const data = result.data.shareCase
            for (const i in data) {
              this.addForm[i] = data[i]
            }
            this.businessTypeChange(this.addForm.businessType)
            this.init()
          } else {
            this.pwdPass = false
            this.$common.session.remove('pwd')
            this.$dialog.alert({
              message: result.msg
            })
          }
        },
        error => {
          this.pwdPass = false
          this.$common.session.remove('pwd')
          this.$dialog.alert({
            message: error.name + ':' + error.message
          })
        }
      )
    },
    // 获取所有员工
    queryUserIdName() {
      const param = {}
      this.$get('/user/queryUserIdName', param).then(
        result => {
          if (result.status === 200) {
            this.persons = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 查询股东
    queryShareholder() {
      const param = {
        caseId: this.addForm.id,
        pwd: this.pwd
      }
      this.$get('case/queryShareCaseShareholder', param).then(
        result => {
          if (result.status === 200) {
            this.caseShareholders = result.data
          } else {
            this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
          }
        },
        error => {
          this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
        }
      )
    },
    // 新增股东
    addCaseShareholder() {
      this.caseShareholderForm = {
        name: '',
        shareProportion: '',
        idcardEmblem: '', // 股东身份证国徽面
        idcardHead: ''
      }
      this.caseShareholders.push({
        state: 'add',
        name: '',
        idcardEmblem: '',
        idcardHead: ''
      })
    },
    // 股东保存
    caseShareholderFormSave(index, data) {
      if (!this.caseShareholderForm.name) {
        return this.$toast('请填写股东！')
      }
      if (!this.caseShareholderForm.shareProportion) {
        return this.$toast('请填写占股比例！')
      }
      if (this.caseShareholderForm.shareProportion > 100 || this.caseShareholderForm.shareProportion < 0) {
        return this.$toast('占股比例不得大于100，不得小于0！')
      }
      if (!this.caseShareholderForm.idcardEmblem) {
        return this.$toast('请上传股东身份证国徽面！')
      }
      if (!this.caseShareholderForm.idcardHead) {
        return this.$toast('请上传股东身份证头像面！')
      }
      if (this.addForm.id) {
        const param = {
          caseId: this.addForm.id,
          name: this.caseShareholderForm.name,
          shareProportion: this.caseShareholderForm.shareProportion,
          idcardEmblem: this.caseShareholderForm.idcardEmblem,
          idcardHead: this.caseShareholderForm.idcardHead,
          pwd: this.pwd
        }
        this.$post('/case/addShareCaseShareholder', param).then(
          result => {
            if (result.status === 200) {
              this.queryShareholder()
              this.caseShareholders[index].state = ''
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
            } else {
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
            }
          },
          error => {
            this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
          }
        )
      } else {
        this.caseShareholders[index] = this.caseShareholderForm
        this.caseShareholders[index].state = ''
        this.caseShareholders = this.$common.jsonStr(this.caseShareholders)
      }
    },
    // 删除股东
    delCaseShareholder(index, data) {
      if (data.id) {
        const param = {
          id: data.id,
          pwd: this.pwd
        }
        this.$root.$children[0].vueConfirm({ message: '确定要删除股东？', type: 'warning' }, () => {
          this.$get('/case/deleteShareCaseShareholder', param).then(
            result => {
              if (result.status === 200 || result.status === 0) {
                this.queryShareholder()
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        })
      } else {
        this.caseShareholders.splice(index, 1)
      }
    },
    // 图片预览
    picRead(e) {
      const _this = this
      var files = e.target.files[0]
      console.log(e)
      if (!e || !window.FileReader) return // 看支持不支持FileReader
      const reader = new FileReader()
      reader.readAsDataURL(files) // 这里是最关键的一步，转换就在这里
      reader.onloadend = function() {
        _this[e.target.name] = {
          src: this.result,
          file: e.target.files[0]
        }
        _this.addForm[e.target.name] = e.target.files[0]
        _this.$refs[e.target.name].value = ''
      }
    },
    // 图片预览
    picReadUpload(e, formName) {
      const names = {
        idcardEmblem: '股东身份证国徽面',
        idcardHead: '股东身份证头像面',
        supervisorIdcardEmblem: '监事身份证国徽面', // 监事身份证国徽面
        supervisorIdcardHead: '监事身份证头像面', // 监事身份证头像面
        treasurerIdcardEmblem: '财务负责人身份证国徽面', // 财务负责人身份证国徽面
        treasurerIdcardHead: '财务负责人身份证头像面', // 财务负责人身份证头像面
        legalPersonIdcardEmblem: '法人身份证国徽面', // 法人身份证国徽面
        legalPersonIdcardHead: '法人身份证头像面' // 法人身份证头像面
      }
      var files = e.target.files[0]
      if (!e || !window.FileReader) return // 看支持不支持FileReader
      const reader = new FileReader()
      reader.readAsDataURL(files) // 这里是最关键的一步，转换就在这里
      reader.onloadend = () => {
        const pic = e.target.files[0]
        this.$refs[e.target.name].value = ''
        const param = new FormData()
        param.append('oid', 0)
        param.append('name', names[e.target.name])
        param.append('pic', pic)
        this.$formData('/case/pic/upload', param).then(
          result => {
            if (result.status === 200) {
              const form = this[formName]
              form[e.target.name] = result.data.url
              this[formName] = form
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
            } else {
              this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
            }
          },
          error => {
            this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
          }
        )
      }
    },
    // 新增保存
    addSave(name) {
      console.log(this.$common.jsonStr(this.addForm))
      this.$refs[name].validate(valid => {
        if (valid) {
          console.log('通过')
          const param = {
            shareCase: {
              id: this.addForm.id,
              caseId: this.addForm.id,
              pwd: this.pwd,
              companyName: this.addForm.companyName, // 公司名称
              companyName1: this.addForm.companyName1 || '', // 公司名称
              customerManagerId: this.addForm.customerManagerId, // 客户经理id
              customerManagerName: this.addForm.customerManagerName, // 客户经理姓名
              area1: this.addForm.area1,
              area2: this.addForm.area2,
              area3: this.addForm.area3,
              address: this.addForm.address, // 地址
              businessType: this.addForm.businessType, // 业务类型
              caseType: this.addForm.caseType, // 案件类型
              natureOfBusiness: this.addForm.natureOfBusiness, // 经营范围
              registeredCapital: this.addForm.registeredCapital, // 注册资金
              remark: this.addForm.remark, // 业务说明（备注）
              taxNature: this.addForm.taxNature, // 纳税性质
              isBookkeeping: this.addForm.isBookkeeping, // 是否代理记账
              advancePayment: this.addForm.advancePayment, // 预付款
              finalPayment: this.addForm.finalPayment, // 尾款

              supervisor: this.addForm.supervisor, // 监事
              supervisorIdcardEmblem: this.addForm.supervisorIdcardEmblem, // 监事身份证国徽面
              supervisorIdcardHead: this.addForm.supervisorIdcardHead, // 监事身份证头像面
              treasurer: this.addForm.treasurer, // 财务负责人
              treasurerIdcardEmblem: this.addForm.treasurerIdcardEmblem, // 财务负责人身份证国徽面
              treasurerIdcardHead: this.addForm.treasurerIdcardHead, // 财务负责人身份证头像面
              legalPerson: this.addForm.legalPerson, // 法人
              legalPersonIdcardEmblem: this.addForm.legalPersonIdcardEmblem, // 法人身份证国徽面
              legalPersonIdcardHead: this.addForm.legalPersonIdcardHead // 法人身份证头像面
            },
            shareholders: this.caseShareholders // 股东
          }
          this.$post('/case/fillInTheShareCase', param).then(
            result => {
              if (result.status === 200) {
                this.web = 'main'
                this.titles = ['案件中心']
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'success' })
                this.$emit('save')
              } else {
                this.$root.$children[0].vueAlert({ message: result.msg, type: 'error' })
              }
            },
            error => {
              this.$root.$children[0].vueAlert({ message: error.name + ':' + error.message, type: 'error' })
            }
          )
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onResize() {
      const bodyWidth = document.body.getBoundingClientRect().width
      if (bodyWidth <= 768) {
        this.showState = 'phone'
      } else {
        this.showState = 'pc'
      }
    },
    is_weixn() {
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) === 'micromessenger') {
        return true
      } else {
        return false
      }
    },
    sign(link) {
      console.log(link)
      const param = {
        // cid: this.$route.params.id,
        cid: '1',
        url: window.location.href.split('#')[0]
      }
      console.log(param)
      this.$formUrlencoded('/wechat/sign', param).then(
        result => {
          if (result.status === 200) {
            wx.config({
              debug: false,
              // appId: 'wx3eb7e979c4024c83',
              // appId: 'wx5d4de6267db6f700', // 联众
              appId: 'wx66b5ace206eaded0', // 联众
              timestamp: result.data.timestamp,
              nonceStr: result.data.nonceStr,
              signature: result.data.signature,
              jsApiList: [
                'onMenuShareTimeline',
                'onMenuShareAppMessage',
                'onMenuShareQQ',
                'onMenuShareQZone',
                'updateAppMessageShareData',
                'updateTimelineShareData',
                'onMenuShareWeibo'
              ]
            })
            wx.ready(function() {
              // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
              wx.updateAppMessageShareData({
                title: '代账公司智能系统', // 分享标题
                desc:
                  '代账公司智能OA系统，多人协同作业，数据云端保存，工商案件、客户收款登记一键录入，手机端+PC端随时查阅！', // 分享描述
                link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'http://17l.link/dist/icon-logo.jpg', // 分享图标
                success: function() {
                  // 设置成功
                }
              })
              // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
              wx.updateTimelineShareData({
                title: '代账公司智能系统', // 分享标题
                link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'http://17l.link/dist/icon-logo.jpg', // 分享图标
                success: function() {
                  // 设置成功
                }
              })
              // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口（即将废弃）
              wx.onMenuShareTimeline({
                title: '代账公司智能系统', // 分享标题
                link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'http://17l.link/dist/icon-logo.jpg', // 分享图标
                success: function() {
                  // 用户点击了分享后执行的回调函数
                }
              })
              // 获取“分享给朋友”按钮点击状态及自定义分享内容接口（即将废弃）
              wx.onMenuShareAppMessage({
                title: '代账公司智能系统', // 分享标题
                desc:
                  '代账公司智能OA系统，多人协同作业，数据云端保存，工商案件、客户收款登记一键录入，手机端+PC端随时查阅！', // 分享描述
                link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: 'http://17l.link/dist/icon-logo.jpg', // 分享图标
                type: '', // 分享类型,music、video或link，不填默认为link
                dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
                success: function() {
                  // 用户点击了分享后执行的回调函数
                }
              })
              // 获取“分享到QQ”按钮点击状态及自定义分享内容接口（即将废弃）
              wx.onMenuShareQQ({
                title: '代账公司智能系统', // 分享标题
                desc:
                  '代账公司智能OA系统，多人协同作业，数据云端保存，工商案件、客户收款登记一键录入，手机端+PC端随时查阅！', // 分享描述
                link: link, // 分享链接
                imgUrl: 'http://17l.link/dist/icon-logo.jpg', // 分享图标
                success: function() {
                  // 用户确认分享后执行的回调函数
                },
                cancel: function() {
                  // 用户取消分享后执行的回调函数
                }
              })
              // 获取“分享到腾讯微博”按钮点击状态及自定义分享内容接口
              wx.onMenuShareWeibo({
                title: '代账公司智能系统', // 分享标题
                desc:
                  '代账公司智能OA系统，多人协同作业，数据云端保存，工商案件、客户收款登记一键录入，手机端+PC端随时查阅！', // 分享描述
                link: link, // 分享链接
                imgUrl: 'http://17l.link/dist/icon-logo.jpg', // 分享图标
                success: function() {
                  // 用户确认分享后执行的回调函数
                },
                cancel: function() {
                  // 用户取消分享后执行的回调函数
                }
              })
              // 获取“分享到QQ空间”按钮点击状态及自定义分享内容接口（即将废弃）
              wx.onMenuShareQZone({
                title: '代账公司智能系统', // 分享标题
                desc:
                  '代账公司智能OA系统，多人协同作业，数据云端保存，工商案件、客户收款登记一键录入，手机端+PC端随时查阅！', // 分享描述
                link: link, // 分享链接
                imgUrl: 'http://17l.link/dist/icon-logo.jpg', // 分享图标
                success: function() {
                  // 用户确认分享后执行的回调函数
                },
                cancel: function() {
                  // 用户取消分享后执行的回调函数
                }
              })
            })
            wx.error(res => {
              console.log(res)
              this.$dialog.alert({
                message: '微信授权失败!' + res.errMsg
              })
            })
          } else {
            this.$dialog.alert({
              message: result.msg
            })
          }
        },
        error => {
          this.$dialog.alert({
            message: error.message
          })
        }
      )
    }
  },
  mounted() {
    if (this.is_weixn()) {
      this.sign(window.location.href)
    }
    console.log(this.$route.params)
    if (this.$common.session.get('pwd')) {
      this.pwd = this.$common.session.get('pwd')
      this.queryShareCase()
    }
    window.addEventListener('resize', this.onResize)
    this.onResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  }
}
</script>

<style lang="less" scoped>
.user {
  padding: 2vh 2vw 0;
  .title {
    height: 3vh;
    line-height: 3vh;
    font-size: 2rem;
    margin-bottom: 1.4vh;
  }
}
.edit-page,
.main-page {
  height: 100%;
}
.colspan {
  display: flex;
  span {
    flex: 1;
  }
}
.el-form-item {
  margin-bottom: 12px;
  /deep/.el-form-item__error {
    top: 85%;
  }
  /deep/.el-textarea + .el-form-item__error {
    top: 100%;
  }
}
.img-box {
  position: relative;
  display: inline-flex;
  width: 7vh;
  height: 5vh;
  margin-right: 5vh;
  align-items: center;
  justify-content: center;
  img {
    position: absolute;
    max-width: 100%;
    max-height: 5vh;
    min-height: 2vh;
  }
  .upload {
    display: inline-flex;
    position: relative;
    width: 5vh;
    height: 5vh;
    // color: #ccc;
    // border: 2px solid #ccc;
    line-height: 0;
    align-items: center;
    justify-content: center;
    vertical-align: text-bottom;
    background: url('../../assets/img/icon-upload.png') no-repeat 100% 100%;
    cursor: pointer;
    .upload-file {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 5vh;
      height: 5vh;
      opacity: 0;
      cursor: pointer;
      background: transparent;
    }
  }
  .upload-btn {
    display: inline-flex;
    position: relative;
    align-items: center;
    justify-content: center;
    vertical-align: text-bottom;
    cursor: pointer;
    .upload-file {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      background: transparent;
    }
  }
  .mask {
    display: flex;
    position: relative;
    width: 10vh;
    height: 4vh;
    line-height: 4vh;
    color: #ccc;
    background: #67c23a;
    font-size: 3rem;
    border-radius: 0.5vw;
    line-height: 0;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .mask-file {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      background: transparent;
      z-index: 1000;
    }
    .el-icon-plus {
      font-size: 1.2rem;
      font-weight: bold;
      color: #fff;
      height: 1.2rem;
      line-height: 1;
    }
    .text {
      font-size: 1rem;
      font-weight: bold;
      color: #fff;
      height: 1.2rem;
      line-height: 1;
    }
  }
}
</style>
